module.exports = __webpack_public_path__ + "img/bg-careers-tablet.2ce8dccb.png";